<ion-accordion>

  <ion-item slot="header" lines="none">

    <ion-thumbnail slot="start">
      <img [src]="item.avatar || 'assets/img/empty-img/no_user.png'" alt="">
    </ion-thumbnail>

    <ion-label>

      <div class="title">
        @if (item.activo) {
          <yu-badge type="dot" color="success"></yu-badge>
        }

        {{ item.usuario }}
      </div>

      <div class="description time">
        <yu-icon name="clock-user"></yu-icon>

        <p>
          {{ item.total_time }} | {{ item.fichajes.length }} {{ (item.fichajes.length > 1 ? 'RRHH.CLOCK_IN.CLOCK_IN_PLURAL' : 'RRHH.CLOCK_IN.CLOCK_IN_SINGULAR') | translate }}
        </p>
      </div>

    </ion-label>

  </ion-item>

  <ion-list slot="content" lines="none">

    @for (clockIn of item.fichajes; track clockIn.id) {

      <ion-item-sliding #itemSld>

        <ion-item>

          <ion-label>

            <div class="description time">
              <yu-icon name="clock"></yu-icon>

              <p>
                <span>{{ clockIn.hora_inicio }}</span> a
                <span>{{ clockIn.hora_fin ? clockIn.hora_fin : '--:--' }}</span>

                @if (clockIn.fin_next && clockIn.diff_days > 0) {
                  <sup>+{{ clockIn.diff_days }}</sup>
                }

                @if (clockIn.local) {
                  en <span>{{ clockIn.local }}</span>
                }
              </p>

              @if (clockIn.automatico) {
                <yu-icon name="warning" color="warning"></yu-icon>
              }
            </div>

          </ion-label>

          @if (clockIn.id_estado_firma !== clockInStatusEnum.notRequested) {

            <ion-note>

              <yu-tag [color]="tagManager.getColorTag(clockIn, 'clock-in')">
                {{ clockIn.estado_firma }}
              </yu-tag>

            </ion-note>

          }

        </ion-item>

        <ion-item-options side="end">

          @if (!isMine && permissionsManager.checkPermission('fichajes_globales', 'editar')) {
            <yu-list-action
              color="info"
              (click)="doSlideAction('edit', clockIn, itemSld)"
            >
              <yu-icon slot="top" name="pencil-simple"></yu-icon>
              {{ 'COMMON.EDIT' | translate }}
            </yu-list-action>
          }

          @if (isMine && clockIn.id_estado_firma === clockInStatusEnum.requested) {
            <yu-list-action
              color="success"
              (click)="doSlideAction('sign', clockIn, itemSld)"
            >
              <yu-icon slot="top" name="signature"></yu-icon>
              {{ 'RRHH.CLOCK_IN.SIGN' | translate }}
            </yu-list-action>
          }

        </ion-item-options>

      </ion-item-sliding>

    }

  </ion-list>

</ion-accordion>
